import { Entity } from '@backstage/catalog-model';

export function shouldRenderHerokuInfo(entity: Entity): boolean {
  const pipelineId =
    entity?.metadata?.annotations?.['heroku.com/pipeline-uuid'];

  return (
    !!pipelineId &&
    pipelineId.toLowerCase() !== 'none' &&
    entity.kind === 'Component'
  );
}

export function shouldRenderTerraformWorkspace(entity: Entity): boolean {
  const workspaceName =
    entity?.metadata?.annotations?.['heroku.com/tfc-workspace-name'];

  return (
    !!workspaceName &&
    workspaceName.toLowerCase() !== 'none' &&
    entity.kind === 'Component'
  );
}

export function shouldRenderPagerDutyInfo(entity: Entity): boolean {
  const serviceId = entity?.metadata?.annotations?.['pagerduty.com/service-id'];

  return (
    !!serviceId &&
    serviceId.toLowerCase() !== 'none' &&
    entity.kind === 'Component'
  );
}
